// import PropTypes from "prop-types";
// import React from "react";

// import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

// //redux
// import { useSelector, useDispatch } from "react-redux";
// import { createSelector } from "reselect";
// import { Link } from "react-router-dom";
// import withRouter from "components/Common/withRouter";

// // Formik validation
// import * as Yup from "yup";
// import { useFormik } from "formik";

// // actions
// import { loginUser, socialLogin } from "../../store/actions";

// // import images
// import profile from "assets/images/profile-img.png";
// import logo from "assets/images/logo.svg";

// const Login = props => {

//   //meta title
//   document.title = "Login | Skote - React Admin & Dashboard Template";

//   const dispatch = useDispatch();

//   const validation = useFormik({
//     // enableReinitialize : use this  flag when initial values needs to be changed
//     enableReinitialize: true,

//     initialValues: {
//       email: "admin@themesbrand.com" || '',
//       password: "123456" || '',
//     },
//     validationSchema: Yup.object({
//       email: Yup.string().required("Please Enter Your Email"),
//       password: Yup.string().required("Please Enter Your Password"),
//     }),
//     onSubmit: (values) => {
//       dispatch(loginUser(values, props.router.navigate));
//     }
//   });

//   const LoginProperties = createSelector(
//     (state) => state.Login,
//     (login) => ({
//       error: login.error
//     })
//   );

//   const {
//     error
//   } = useSelector(LoginProperties);

//   const signIn = type => {
//     dispatch(socialLogin(type, props.router.navigate));
//   };

//   //for facebook and google authentication
//   const socialResponse = type => {
//     signIn(type);
//   };

//   //handleTwitterLoginResponse
//   // const twitterResponse = e => {}

//   return (
//     <React.Fragment>
//       <div className="account-pages my-5 pt-sm-5">
//         <Container>
//           <Row className="justify-content-center">
//             <Col md={8} lg={6} xl={5}>
//               <Card className="overflow-hidden">
//                 <div className="bg-primary-subtle">
//                   <Row>
//                     <Col className="col-7">
//                       <div className="text-primary p-4">
//                         <h5 className="text-primary">Welcome Back !</h5>
//                         <p>Sign in to continue to Skote.</p>
//                       </div>
//                     </Col>
//                     <Col className="col-5 align-self-end">
//                       <img src={profile} alt="" className="img-fluid" />
//                     </Col>
//                   </Row>
//                 </div>
//                 <CardBody className="pt-0">
//                   <div>
//                     <Link to="/" className="logo-light-element">
//                       <div className="avatar-md profile-user-wid mb-4">
//                         <span className="avatar-title rounded-circle bg-light">
//                           <img
//                             src={logo}
//                             alt=""
//                             className="rounded-circle"
//                             height="34"
//                           />
//                         </span>
//                       </div>
//                     </Link>
//                   </div>
//                   <div className="p-2">
//                     <Form
//                       className="form-horizontal"
//                       onSubmit={(e) => {
//                         e.preventDefault();
//                         validation.handleSubmit();
//                         return false;
//                       }}
//                     >
//                       {error ? <Alert color="danger">{error}</Alert> : null}

//                       <div className="mb-3">
//                         <Label className="form-label">Email</Label>
//                         <Input
//                           name="email"
//                           className="form-control"
//                           placeholder="Enter email"
//                           type="email"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           value={validation.values.email || ""}
//                           invalid={
//                             validation.touched.email && validation.errors.email ? true : false
//                           }
//                         />
//                         {validation.touched.email && validation.errors.email ? (
//                           <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="mb-3">
//                         <Label className="form-label">Password</Label>
//                         <Input
//                           name="password"
//                           value={validation.values.password || ""}
//                           type="password"
//                           placeholder="Enter Password"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           invalid={
//                             validation.touched.password && validation.errors.password ? true : false
//                           }
//                         />
//                         {validation.touched.password && validation.errors.password ? (
//                           <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="form-check">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customControlInline"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customControlInline"
//                         >
//                           Remember me
//                         </label>
//                       </div>

//                       <div className="mt-3 d-grid">
//                         <button
//                           className="btn btn-primary btn-block"
//                           type="submit"
//                         >
//                           Log In
//                         </button>
//                       </div>

//                       <div className="mt-4 text-center">
//                         <h5 className="font-size-14 mb-3">Sign in with</h5>

//                         <ul className="list-inline">
//                           <li className="list-inline-item">
//                             <Link
//                               to="#"
//                               className="social-list-item bg-primary text-white border-primary"
//                               onClick={e => {
//                                 e.preventDefault();
//                                 socialResponse("facebook");
//                               }}
//                             >
//                               <i className="mdi mdi-facebook" />
//                             </Link>
//                           </li>
//                           {/*<li className="list-inline-item">*/}
//                           {/*  <TwitterLogin*/}
//                           {/*    loginUrl={*/}
//                           {/*      "http://localhost:4000/api/v1/auth/twitter"*/}
//                           {/*    }*/}
//                           {/*    onSuccess={this.twitterResponse}*/}
//                           {/*    onFailure={this.onFailure}*/}
//                           {/*    requestTokenUrl={*/}
//                           {/*      "http://localhost:4000/api/v1/auth/twitter/revers"*/}
//                           {/*    }*/}
//                           {/*    showIcon={false}*/}
//                           {/*    tag={"div"}*/}
//                           {/*  >*/}
//                           {/*    <a*/}
//                           {/*      href=""*/}
//                           {/*      className="social-list-item bg-info text-white border-info"*/}
//                           {/*    >*/}
//                           {/*      <i className="mdi mdi-twitter"/>*/}
//                           {/*    </a>*/}
//                           {/*  </TwitterLogin>*/}
//                           {/*</li>*/}
//                           <li className="list-inline-item">
//                             <Link
//                               to="#"
//                               className="social-list-item bg-danger text-white border-danger"
//                               onClick={e => {
//                                 e.preventDefault();
//                                 socialResponse("google");
//                               }}
//                             >
//                               <i className="mdi mdi-google" />
//                             </Link>
//                           </li>
//                         </ul>
//                       </div>

//                       <div className="mt-4 text-center">
//                         <Link to="/forgot-password" className="text-muted">
//                           <i className="mdi mdi-lock me-1" />
//                           Forgot your password?
//                         </Link>
//                       </div>
//                     </Form>
//                   </div>
//                 </CardBody>
//               </Card>
//               <div className="mt-5 text-center">
//                 <p>
//                   Don&#39;t have an account ?{" "} <Link to="/register" className="fw-medium text-primary">
//                     {" "}
//                     Signup now{" "}
//                   </Link>{" "}
//                 </p>
//                 <p>
//                   © {new Date().getFullYear()} Skote. Crafted with{" "}
//                   <i className="mdi mdi-heart text-danger" /> by Themesbrand
//                 </p>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   );
// };

// export default withRouter(Login);

// Login.propTypes = {
//   history: PropTypes.object,
// };

// import PropTypes from "prop-types"
// import React from "react"

// import {
//   Row,
//   Col,
//   CardBody,
//   Card,
//   Alert,
//   Container,
//   Form,
//   Input,
//   FormFeedback,
//   Label,
// } from "reactstrap"

// //redux
// import { useSelector, useDispatch } from "react-redux"
// import { createSelector } from "reselect"
// import { Link } from "react-router-dom"
// import withRouter from "components/Common/withRouter"

// // Formik validation
// import * as Yup from "yup"
// import { useFormik } from "formik"

// // actions
// import { loginUser } from "../../store/actions"

// // import images
// import profile from "assets/images/profile-img.png"

// const Login = props => {
//   // Updated meta title
//   document.title = "Login | Omni-Report"

//   const dispatch = useDispatch()

//   const validation = useFormik({
//     enableReinitialize: true,
//     initialValues: {
//       email: "admin@themesbrand.com" || "",
//       password: "123456" || "",
//     },
//     validationSchema: Yup.object({
//       email: Yup.string().required("Please Enter Your Email"),
//       password: Yup.string().required("Please Enter Your Password"),
//     }),
//     onSubmit: values => {
//       dispatch(loginUser(values, props.router.navigate))
//     },
//   })

//   const LoginProperties = createSelector(
//     state => state.Login,
//     login => ({
//       error: login.error,
//     })
//   )

//   const { error } = useSelector(LoginProperties)

//   return (
//     <React.Fragment>
//       <div className="account-pages my-5 pt-sm-5">
//         <Container>
//           <Row className="justify-content-center">
//             <Col md={8} lg={6} xl={5}>
//               <Card className="overflow-hidden">
//                 <div className="bg-primary-subtle">
//                   <Row>
//                     <Col className="col-7">
//                       <div className="text-primary p-4">
//                         <h5 className="text-primary">Welcome Back !</h5>
//                         <p>Sign in to continue to Omni-Report.</p>
//                       </div>
//                     </Col>
//                     <Col className="col-5 align-self-end">
//                       <img src={profile} alt="" className="img-fluid" />
//                     </Col>
//                   </Row>
//                 </div>
//                 <CardBody className="pt-0">
//                   <div className="p-2">
//                     <Form
//                       className="form-horizontal"
//                       onSubmit={e => {
//                         e.preventDefault()
//                         validation.handleSubmit()
//                         return false
//                       }}
//                     >
//                       {error ? <Alert color="danger">{error}</Alert> : null}

//                       <div className="mb-3">
//                         <Label className="form-label">Email</Label>
//                         <Input
//                           name="email"
//                           className="form-control"
//                           placeholder="Enter email"
//                           type="email"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           value={validation.values.email || ""}
//                           invalid={
//                             validation.touched.email && validation.errors.email
//                               ? true
//                               : false
//                           }
//                         />
//                         {validation.touched.email && validation.errors.email ? (
//                           <FormFeedback type="invalid">
//                             {validation.errors.email}
//                           </FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="mb-3">
//                         <Label className="form-label">Password</Label>
//                         <Input
//                           name="password"
//                           value={validation.values.password || ""}
//                           type="password"
//                           placeholder="Enter Password"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           invalid={
//                             validation.touched.password &&
//                             validation.errors.password
//                               ? true
//                               : false
//                           }
//                         />
//                         {validation.touched.password &&
//                         validation.errors.password ? (
//                           <FormFeedback type="invalid">
//                             {validation.errors.password}
//                           </FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="form-check">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customControlInline"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customControlInline"
//                         >
//                           Remember me
//                         </label>
//                       </div>

//                       <div className="mt-3 d-grid">
//                         <button
//                           className="btn btn-primary btn-block"
//                           type="submit"
//                         >
//                           Log In
//                         </button>
//                       </div>

//                       <div className="mt-4 text-center">
//                         <Link to="/forgot-password" className="text-muted">
//                           <i className="mdi mdi-lock me-1" />
//                           Forgot your password?
//                         </Link>
//                       </div>
//                     </Form>
//                   </div>
//                 </CardBody>
//               </Card>

//               <div className="mt-5 text-center">
//                 <p>
//                   Don't have an account ?{" "}
//                   <Link to="/register" className="fw-medium text-primary">
//                     Signup now
//                   </Link>{" "}
//                 </p>
//                 <p>
//                   © {new Date().getFullYear()} Omni-Report. Crafted with{" "}
//                   <i className="mdi mdi-heart text-danger" /> by Marcadeo
//                 </p>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   )
// }

// export default withRouter(Login)

// Login.propTypes = {
//   history: PropTypes.object,
// }

// import React, { useState } from "react"
// import {
//   Row,
//   Col,
//   CardBody,
//   Card,
//   Alert,
//   Container,
//   Form,
//   Input,
//   FormFeedback,
//   Label,
//   Spinner,
// } from "reactstrap"

// // Formik Validation
// import * as Yup from "yup"
// import { useFormik } from "formik"

// import { Link, useNavigate } from "react-router-dom"

// // Api helper se login function import
// import { loginUser } from "../../helpers/api_helper"

// // import images
// import profile from "assets/images/profile-img.png"

// const Login = () => {
//   document.title = "Login | Omni-Report"

//   const navigate = useNavigate()
//   const [loading, setLoading] = useState(false)
//   const [errorMsg, setErrorMsg] = useState(null)

//   const validation = useFormik({
//     enableReinitialize: true,
//     initialValues: {
//       email: "", // ya username field rakh sakte ho agar email nahi hai
//       password: "",
//     },
//     validationSchema: Yup.object({
//       email: Yup.string().required("Please Enter Your Email/Username"),
//       password: Yup.string().required("Please Enter Your Password"),
//     }),
//     onSubmit: async values => {
//       setLoading(true)
//       setErrorMsg(null)

//       // Agar backend username expect kar raha hai to email ko username samjho
//       const credentials = {
//         username: values.email, // ya agar email field hai to email: values.email
//         password: values.password,
//       }

//       const result = await loginUser(credentials)

//       setLoading(false)

//       if (result.success) {
//         // Success – dashboard pe redirect
//         navigate("/dashboard") // ya jo bhi tumhara protected route hai
//       } else {
//         setErrorMsg(
//           result.error || "Login failed. Please check your credentials."
//         )
//       }
//     },
//   })

//   return (
//     <React.Fragment>
//       <div className="account-pages my-5 pt-sm-5">
//         <Container>
//           <Row className="justify-content-center">
//             <Col md={8} lg={6} xl={5}>
//               <Card className="overflow-hidden">
//                 <div className="bg-primary-subtle">
//                   <Row>
//                     <Col className="col-7">
//                       <div className="text-primary p-4">
//                         <h5 className="text-primary">Welcome Back !</h5>
//                         <p>Sign in to continue to Omni-Report.</p>
//                       </div>
//                     </Col>
//                     <Col className="col-5 align-self-end">
//                       <img src={profile} alt="" className="img-fluid" />
//                     </Col>
//                   </Row>
//                 </div>

//                 <CardBody className="pt-0">
//                   <div className="p-2">
//                     <Form
//                       className="form-horizontal"
//                       onSubmit={e => {
//                         e.preventDefault()
//                         validation.handleSubmit()
//                         return false
//                       }}
//                     >
//                       {errorMsg && <Alert color="danger">{errorMsg}</Alert>}

//                       <div className="mb-3">
//                         <Label className="form-label">Email / Username</Label>
//                         <Input
//                           name="email"
//                           className="form-control"
//                           placeholder="Enter email or username"
//                           type="text" // email ya username dono accept karega
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           value={validation.values.email || ""}
//                           invalid={
//                             validation.touched.email && validation.errors.email
//                               ? true
//                               : false
//                           }
//                         />
//                         {validation.touched.email && validation.errors.email ? (
//                           <FormFeedback type="invalid">
//                             {validation.errors.email}
//                           </FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="mb-3">
//                         <Label className="form-label">Password</Label>
//                         <Input
//                           name="password"
//                           value={validation.values.password || ""}
//                           type="password"
//                           placeholder="Enter Password"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           invalid={
//                             validation.touched.password &&
//                             validation.errors.password
//                               ? true
//                               : false
//                           }
//                         />
//                         {validation.touched.password &&
//                         validation.errors.password ? (
//                           <FormFeedback type="invalid">
//                             {validation.errors.password}
//                           </FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="form-check">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customControlInline"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customControlInline"
//                         >
//                           Remember me
//                         </label>
//                       </div>

//                       <div className="mt-3 d-grid">
//                         <button
//                           className="btn btn-primary btn-block"
//                           type="submit"
//                           disabled={loading}
//                         >
//                           {loading ? (
//                             <>
//                               <Spinner size="sm" className="me-2" /> Logging
//                               in...
//                             </>
//                           ) : (
//                             "Log In"
//                           )}
//                         </button>
//                       </div>

//                       <div className="mt-4 text-center">
//                         <Link to="/forgot-password" className="text-muted">
//                           <i className="mdi mdi-lock me-1" />
//                           Forgot your password?
//                         </Link>
//                       </div>
//                     </Form>
//                   </div>
//                 </CardBody>
//               </Card>

//               <div className="mt-5 text-center">
//                 <p>
//                   Don't have an account ?{" "}
//                   <Link to="/register" className="fw-medium text-primary">
//                     Signup now
//                   </Link>
//                 </p>
//                 <p>
//                   © {new Date().getFullYear()} Omni-Report. Crafted with{" "}
//                   <i className="mdi mdi-heart text-danger" /> by Marcadeo
//                 </p>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   )
// }

// export default Login

// import React, { useState } from "react"
// import {
//   Row,
//   Col,
//   CardBody,
//   Card,
//   Alert,
//   Container,
//   Form,
//   Input,
//   FormFeedback,
//   Label,
//   Spinner,
// } from "reactstrap"

// // Formik Validation
// import * as Yup from "yup"
// import { useFormik } from "formik"

// import { Link, useNavigate } from "react-router-dom"

// // Api helper se login function import
// import { loginUser } from "../../helpers/api_helper"

// // import images
// import profile from "assets/images/profile-img.png"

// const Login = () => {
//   document.title = "Login | Omni-Report"

//   const navigate = useNavigate()
//   const [loading, setLoading] = useState(false)
//   const [errorMsg, setErrorMsg] = useState(null)

//   const validation = useFormik({
//     enableReinitialize: true,
//     initialValues: {
//       email: "", // ya username
//       password: "",
//     },
//     validationSchema: Yup.object({
//       email: Yup.string().required("Please Enter Your Email/Username"),
//       password: Yup.string().required("Please Enter Your Password"),
//     }),
//     onSubmit: async values => {
//       setLoading(true)
//       setErrorMsg(null)

//       // Backend ke hisaab se credentials bhej rahe hain
//       const credentials = {
//         username: values.email, // agar backend username expect kar raha hai
//         password: values.password,
//       }

//       const result = await loginUser(credentials)

//       setLoading(false)

//       if (result.success) {
//         navigate("/dashboard") // success pe dashboard pe redirect
//       } else {
//         setErrorMsg(
//           result.error || "Login failed. Please check your credentials."
//         )
//       }
//     },
//   })

//   return (
//     <React.Fragment>
//       <div className="account-pages my-5 pt-sm-5">
//         <Container>
//           <Row className="justify-content-center">
//             <Col md={8} lg={6} xl={5}>
//               <Card className="overflow-hidden">
//                 <div className="bg-primary-subtle">
//                   <Row>
//                     <Col className="col-7">
//                       <div className="text-primary p-4">
//                         <h5 className="text-primary">Welcome Back !</h5>
//                         <p>Sign in to continue to Omni-Report.</p>
//                       </div>
//                     </Col>
//                     <Col className="col-5 align-self-end">
//                       <img src={profile} alt="" className="img-fluid" />
//                     </Col>
//                   </Row>
//                 </div>

//                 <CardBody className="pt-0">
//                   <div className="p-2">
//                     <Form
//                       className="form-horizontal"
//                       onSubmit={e => {
//                         e.preventDefault()
//                         validation.handleSubmit()
//                         return false
//                       }}
//                     >
//                       {errorMsg && <Alert color="danger">{errorMsg}</Alert>}

//                       <div className="mb-3">
//                         <Label className="form-label">Email / Username</Label>
//                         <Input
//                           name="email"
//                           className="form-control"
//                           placeholder="Enter email or username"
//                           type="text"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           value={validation.values.email || ""}
//                           invalid={
//                             validation.touched.email && validation.errors.email
//                               ? true
//                               : false
//                           }
//                         />
//                         {validation.touched.email && validation.errors.email ? (
//                           <FormFeedback type="invalid">
//                             {validation.errors.email}
//                           </FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="mb-3">
//                         <Label className="form-label">Password</Label>
//                         <Input
//                           name="password"
//                           value={validation.values.password || ""}
//                           type="password"
//                           placeholder="Enter Password"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           invalid={
//                             validation.touched.password &&
//                             validation.errors.password
//                               ? true
//                               : false
//                           }
//                           autoComplete="current-password" // ← DOM warning fix
//                         />
//                         {validation.touched.password &&
//                         validation.errors.password ? (
//                           <FormFeedback type="invalid">
//                             {validation.errors.password}
//                           </FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="form-check">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customControlInline"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customControlInline"
//                         >
//                           Remember me
//                         </label>
//                       </div>

//                       <div className="mt-3 d-grid">
//                         <button
//                           className="btn btn-primary btn-block"
//                           type="submit"
//                           disabled={loading}
//                         >
//                           {loading ? (
//                             <>
//                               <Spinner size="sm" className="me-2" /> Logging
//                               in...
//                             </>
//                           ) : (
//                             "Log In"
//                           )}
//                         </button>
//                       </div>

//                       <div className="mt-4 text-center">
//                         <Link to="/forgot-password" className="text-muted">
//                           <i className="mdi mdi-lock me-1" />
//                           Forgot your password?
//                         </Link>
//                       </div>
//                     </Form>
//                   </div>
//                 </CardBody>
//               </Card>

//               <div className="mt-5 text-center">
//                 <p>
//                   Don't have an account ?{" "}
//                   <Link to="/register" className="fw-medium text-primary">
//                     Signup now
//                   </Link>{" "}
//                 </p>
//                 <p>
//                   © {new Date().getFullYear()} Omni-Report. Crafted with{" "}
//                   <i className="mdi mdi-heart text-danger" /> by Marcadeo
//                 </p>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   )
// }

// export default Login

// import React, { useState } from "react"
// import {
//   Row,
//   Col,
//   CardBody,
//   Card,
//   Alert,
//   Container,
//   Form,
//   Input,
//   FormFeedback,
//   Label,
//   Spinner,
// } from "reactstrap"

// // Formik Validation
// import * as Yup from "yup"
// import { useFormik } from "formik"

// import { Link, useNavigate } from "react-router-dom"

// // Api helper se login function import
// import { loginUser } from "../../helpers/api_helper"

// // import images
// import profile from "assets/images/profile-img.png"

// const Login = () => {
//   document.title = "Login | Omni-Report"

//   const navigate = useNavigate()
//   const [loading, setLoading] = useState(false)
//   const [errorMsg, setErrorMsg] = useState(null)

//   const validation = useFormik({
//     enableReinitialize: true,
//     initialValues: {
//       email: "",
//       password: "",
//     },
//     validationSchema: Yup.object({
//       email: Yup.string().required("Please Enter Your Email/Username"),
//       password: Yup.string().required("Please Enter Your Password"),
//     }),
//     onSubmit: async values => {
//       setLoading(true)
//       setErrorMsg(null)

//       // Backend ke hisaab se credentials bhej rahe hain
//       const credentials = {
//         username: values.email.trim(), // agar backend username expect kar raha hai
//         password: values.password,
//       }

//       console.log("Login credentials being sent:", credentials) // debug ke liye

//       const result = await loginUser(credentials)

//       console.log("Login result from api_helper:", result) // yeh console check karna zaroori hai

//       setLoading(false)

//       if (result.success) {
//         console.log("Login success – redirecting to dashboard")
//         navigate("/dashboard") // yeh line call ho rahi hai ya nahi? console check karo
//       } else {
//         setErrorMsg(
//           result.error || "Login failed. Please check your credentials."
//         )
//         console.error("Login failed:", result.error, result.details)
//       }
//     },
//   })

//   return (
//     <React.Fragment>
//       <div className="account-pages my-5 pt-sm-5">
//         <Container>
//           <Row className="justify-content-center">
//             <Col md={8} lg={6} xl={5}>
//               <Card className="overflow-hidden">
//                 <div className="bg-primary-subtle">
//                   <Row>
//                     <Col className="col-7">
//                       <div className="text-primary p-4">
//                         <h5 className="text-primary">Welcome Back !</h5>
//                         <p>Sign in to continue to Omni-Report.</p>
//                       </div>
//                     </Col>
//                     <Col className="col-5 align-self-end">
//                       <img src={profile} alt="" className="img-fluid" />
//                     </Col>
//                   </Row>
//                 </div>

//                 <CardBody className="pt-0">
//                   <div className="p-2">
//                     <Form
//                       className="form-horizontal"
//                       onSubmit={e => {
//                         e.preventDefault()
//                         validation.handleSubmit()
//                         return false
//                       }}
//                     >
//                       {errorMsg && <Alert color="danger">{errorMsg}</Alert>}

//                       <div className="mb-3">
//                         <Label className="form-label">Email / Username</Label>
//                         <Input
//                           name="email"
//                           className="form-control"
//                           placeholder="Enter email or username"
//                           type="text"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           value={validation.values.email || ""}
//                           invalid={
//                             validation.touched.email && validation.errors.email
//                               ? true
//                               : false
//                           }
//                           autoComplete="username" // ← Warning fix
//                         />
//                         {validation.touched.email && validation.errors.email ? (
//                           <FormFeedback type="invalid">
//                             {validation.errors.email}
//                           </FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="mb-3">
//                         <Label className="form-label">Password</Label>
//                         <Input
//                           name="password"
//                           value={validation.values.password || ""}
//                           type="password"
//                           placeholder="Enter Password"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           invalid={
//                             validation.touched.password &&
//                             validation.errors.password
//                               ? true
//                               : false
//                           }
//                           autoComplete="current-password" // ← Warning fix
//                         />
//                         {validation.touched.password &&
//                         validation.errors.password ? (
//                           <FormFeedback type="invalid">
//                             {validation.errors.password}
//                           </FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="form-check">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customControlInline"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customControlInline"
//                         >
//                           Remember me
//                         </label>
//                       </div>

//                       <div className="mt-3 d-grid">
//                         <button
//                           className="btn btn-primary btn-block"
//                           type="submit"
//                           disabled={loading}
//                         >
//                           {loading ? (
//                             <>
//                               <Spinner size="sm" className="me-2" /> Logging
//                               in...
//                             </>
//                           ) : (
//                             "Log In"
//                           )}
//                         </button>
//                       </div>

//                       <div className="mt-4 text-center">
//                         <Link to="/forgot-password" className="text-muted">
//                           <i className="mdi mdi-lock me-1" />
//                           Forgot your password?
//                         </Link>
//                       </div>
//                     </Form>
//                   </div>
//                 </CardBody>
//               </Card>

//               <div className="mt-5 text-center">
//                 <p>
//                   Don't have an account ?{" "}
//                   <Link to="/register" className="fw-medium text-primary">
//                     Signup now
//                   </Link>{" "}
//                 </p>
//                 <p>
//                   © {new Date().getFullYear()} Omni-Report. Crafted with{" "}
//                   <i className="mdi mdi-heart text-danger" /> by Marcadeo
//                 </p>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   )
// }

// export default Login

import React, { useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Spinner,
} from "reactstrap"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import { Link, useNavigate } from "react-router-dom"

// Api helper se login function import
import { loginUser } from "../../helpers/api_helper"

// import images
import profile from "assets/images/profile-img.png"

const Login = () => {
  document.title = "Login | Omni-Report"

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState(null)

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email/Username"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async values => {
      setLoading(true)
      setErrorMsg(null)

      const credentials = {
        username: values.email.trim(),
        password: values.password,
      }

      // Development mein debug ke liye
      if (process.env.NODE_ENV === "development") {
        console.log("Login credentials being sent:", credentials)
      }

      const result = await loginUser(credentials)

      if (process.env.NODE_ENV === "development") {
        console.log("Login result from api_helper:", result)
      }

      setLoading(false)

      if (result.success) {
        if (process.env.NODE_ENV === "development") {
          console.log("Login success – redirecting to dashboard")
        }

        // Redirect with replace to clean history
        navigate("/dashboard", { replace: true })
      } else {
        setErrorMsg(
          result.error || "Login failed. Please check your credentials."
        )
        if (process.env.NODE_ENV === "development") {
          console.error("Login failed:", result.error, result.details)
        }
      }
    },
  })

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to Omni-Report.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>

                <CardBody className="pt-0">
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      {errorMsg && (
                        <Alert color="danger" timeout={5000}>
                          {errorMsg}
                        </Alert>
                      )}

                      <div className="mb-3">
                        <Label className="form-label">Email / Username</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email or username"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                          autoComplete="username"
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                          autoComplete="current-password"
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <Spinner size="sm" className="me-2" /> Logging
                              in...
                            </>
                          ) : (
                            "Log In"
                          )}
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-5 text-center">
                <p>
                  Don't have an account ?{" "}
                  <Link to="/register" className="fw-medium text-primary">
                    Signup now
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Omni-Report. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Marcadeo
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Login
